import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { HelperService } from './public/helper.service';
import { startPageRoute } from './public/store/utils/WidgetPageUtils';

@Injectable({
  providedIn: 'root',
})
export class AppModeGuard {
  subdomain: string;
  constructor(
    private router: Router,
    private helperService: HelperService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    if (this.helperService.isMobileApp()) {
      if (this.helperService.isGoAdminApp()) {
        this.router.navigate(['/manager']);
      } else {
        // Story #11856: a template app that opens on its start page replaces
        // the page the WebView launched on rather than stacking on top of it,
        // so the app starts with a single history entry. Android Back on the
        // start page then has no '/' to go back to; before, it went back to
        // '/', which redirected to an empty Menu and raised the promotion
        // pop-up (what Back does there instead is AppComponent's). Apps whose
        // first tab is the Menu, and later passes through '/' (a store
        // switch, an error page), keep their history.
        this.router.navigate(['/public'], {
          replaceUrl: startPageRoute() !== null && !this.router.navigated,
        });
      }
      return false;
    }
    return true;
  }
}
